import { render, staticRenderFns } from "./TrendTile.vue?vue&type=template&id=d552a0ba&lang=pug&"
import script from "./TrendTile.vue?vue&type=script&lang=js&"
export * from "./TrendTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports